import { render, staticRenderFns } from "./DeviceActionCardFooter.vue?vue&type=template&id=6b55a7fe"
import script from "./DeviceActionCardFooter.vue?vue&type=script&lang=js"
export * from "./DeviceActionCardFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports